import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import VeiculosService from '../../../../services/veiculos-auth';
import SecretariaService from '../../../../services/secretaria';
import Veiculo from './veiculo';


const ListarVeiculos = () => {


    const [veiculos, setVeiculos] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [veiculo, setVeiculo] = useState("");
    const [secretarias, setSecretarias] = useState([]);


    const montaSec = async () => {
        const secs = await SecretariaService.listar()
        setSecretarias(secs.data)
    }

    async function fetchVeiculos() {
        await montaSec()
        const response = await VeiculosService.listar();
        if (response.data.length >= 1) {
            setVeiculos(response.data)
            setVazio(false)
        } else {
            setVeiculos([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setVeiculo(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar o veículo?')) {
            await VeiculosService.deletar(id)
            alert("Veículo deletado com sucesso!")
            fetchVeiculos();
        }
    }

    useEffect(() => {
        fetchVeiculos();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/veiculos/editar/${veiculo}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setVeiculos={setVeiculos}
                        setVazio={setVazio}
                        fetchVeiculos={fetchVeiculos}
                        secretarias={secretarias}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={3}>
                            {veiculos.map((veiculo, index) =>
                                <Veiculo
                                    fetchVeiculos={fetchVeiculos}
                                    veiculo={veiculo}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarVeiculos;